import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const InformationCircleIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  width: "1rem",
  height: "1rem",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    d: "M12 1.5A10.5 10.5 0 1 0 22.5 12 10.5 10.5 0 0 0 12 1.5M12 6a1.498 1.498 0 1 1-1.498 1.498A1.5 1.5 0 0 1 12 6m1.493 10.676a1.5 1.5 0 0 1-2.98.001l-.01-.175-.003-4.501.01-.176a1.5 1.5 0 0 1 2.98 0l.01.175.003 4.501z"
  })
});
export default InformationCircleIcon;